import { createVNode } from 'vue';

function markText(mark, classes, style) {
  return createVNode("span", {
    "class": classes ? `se-fictional-text ${classes.join(' ')}` : 'se-fictional-text',
    "style": style,
    "data-text": mark
  }, null);
}

export { markText };
//# sourceMappingURL=mark-text.js.map
